<template>
    <div v-if="this.shouldBeVisible" class="shopstate-popup-container">
        <modal
            id="shop-active-modal"
            :centered="true"
            :show="shopStateModal.show"
            :close="shopStateModal.hide"
            :closeable="shopStateModal.closeable"
            :tighter-close-button="true"
            :title="$t('shop.inactiveModalTitle')"
            size="modal-lg"
            @modal-opening="onModalOpening"
            @modal-visible="onResize"
            @modal-close="onModalClosing"
        >
            <form
                method="post"
                action=""
                enctype="multipart/form-data"
                @submit="onFormSubmit($event)"
                class="cancel-order-popup-form"
                :style="formStyle"
                ref="shopStateForm"
            >
                <div class="modal-body pt-0">
                    <div class="row">
                        <div
                            class="col-12"
                            v-if="response.show && typeof response.message === 'string' && response.message.length > 0"
                        >
                            <div
                                class="alert"
                                :class="{
                                    'alert-success': response.success,
                                    'alert-danger': !response.success,
                                }"
                            >
                                <p class="mb-0">{{ response.message }}</p>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <p v-html="$t('shop.inactiveModalText')"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-end bg-light">
                    <button
                        class="btn btn-secondary"
                        type="button"
                        v-html="$t('generic.cancel')"
                        @click.prevent="hideModal"
                    ></button>
                    <button type="submit" class="btn btn-primary" :disabled="runningRequest">
                        <i v-if="runningRequest" class="mdi mdi-loading mdi-spin" style="margin-right: 5px"></i>
                        <span v-html="$t('shop.inactiveModalButton')"></span>
                    </button>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        email: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            shopStateModal: {
                show: false,
                hide: false,
                closeable: true,
            },
            csrfToken: null,
            formStyle: {
                height: '100%',
            },
            bodyStyle: {
                height: '100%',
            },
            confirmError: false,
            confirm: false,
            formErrors: {},
            runningRequest: false,
            response: {
                show: false,
                success: false,
                message: null,
            },
        };
    },

    computed: {
        /**
         * Determine if the setup popup of order should be visible.
         *
         * @returns {Boolean}
         */
        shouldBeVisible() {
            return true;
        },
    },

    methods: {
        /**
         * Handle the visibility update of the modal.
         *
         * @returns {this}
         */
        showModal() {
            this.shopStateModal.show = true;
            this.shopStateModal.hide = false;
            this.shopStateModal.closeable = true;

            return this;
        },

        hideModal() {
            this.shopStateModal.show = false;
            this.shopStateModal.hide = true;
            this.shopStateModal.closeable = true;

            return this;
        },

        /**
         * Handle the event callback of opening modal.
         *
         * @returns {void}
         */
        onModalOpening() {
            this.$el.ownerDocument.body.classList.add('overflow-hidden');
        },

        /**
         * Handle the event callback for closing modal.
         *
         * @returns {void}
         */
        onModalClosing() {
            this.$el.ownerDocument.body.classList.remove('overflow-hidden');
            this.hideModal();
        },

        /**
         * Handle the submit callback of form to send the expected request.
         *
         * @param {SubmitEvent} $event
         *
         * @returns {void}
         */
        onFormSubmit($event) {
            $event.preventDefault();

            // In the case the form was already submitted, we have to prevent another submit.
            if (this.runningRequest) {
                return;
            }

            // Update the is submitting flag and reset the response alert.
            this.runningRequest = true;
            this.formErrors = {};
            this.response.show = false;
            this.response.success = false;
            this.response.message = null;
            this.confirmError = false;

            axios
                .post('/' + this.$language + '/backend/shopnotify', { email: this.email })
                .then((response) => {
                    // In the case the request was failed for some reason, we have to apply
                    // the message to our response property to show the user more details why
                    // the request was failed.
                    this.response.success = response.data.success;
                    this.response.message = response.data.message;

                    if (!this.response.success) {
                        // In the case that the response contains more details about the exact reason
                        // of failure, we have to provide them by adding these to the formErrors property.
                        if (typeof response.data.formErrors === 'object') {
                            // After the check above, we can assign the errors to the property.
                            this.formErrors = response.data.formErrors;
                        }

                        // Finally, disable the request blocking and show the response message in
                        // an alert container.
                        this.response.show = true;
                        this.runningRequest = false;

                        return;
                    }

                    // Show the success message and reload the page after 2 seconds, to assure
                    // we will show an updated page view with all necessary data.
                    this.response.show = true;
                })
                .finally(() => {
                    this.runningRequest = false;
                });
        },

        /**
         * Handle the callback of resize event, to assure the header size will be tracked correctly.
         *
         * @returns {void}
         */
        onResize() {},
    },

    beforeUnmount() {
        window.removeEventListener('resize', () => {
            this.onResize();
        });
    },

    beforeMount() {
        window.addEventListener('resize', () => {
            this.onResize();
        });
    },

    mounted() {
        this.hideModal();
    },
};
</script>
<style lang="scss"></style>
